export enum Team {
    Deal_Associate = "Deal_Associate",
    Investor_Relations = "investorRelations",
    Treasury = "Treasury",
    Technical = "Technical",
    Accounting = "finance",
    Deal_Execution = "Deal_Execution",
    Deal_Senior = "Deal_Senior"
}

export const TeamLabel = {
    Deal_Associate: "Deal Team",
    investorRelations: "IR Team",
    Treasury: "Treasury Team",
    Technical: "Technical Team",
    finance: "Accounts Team",
    Deal_Execution: "Deal Team - Execution",
    Deal_Senior: "Deal Team - Senior"
}